import { MapPin, CalendarFold, Users } from 'lucide-react';

const Type4TopBanner = (props) => {

    const {
        flights,
        bookingEngine,
        filteredFlights,
        showSearchPageForm,
        setShowSearchPageForm,
    } = props;

    const styles = {
      container: {
        backgroundColor: '#f8fafc',
        fontFamily: "'Inter', sans-serif",
        display: 'flex',
        flexDirection: 'column',
      },
      searchContainer: {
        background: '#ffffff',
        borderBottom: '1px solid #e2e8f0',
        padding: '2rem 0',
      },
      searchBar: {
        background: '#f1f5f9',
        padding: '0.5rem',
        borderRadius: '1.25rem',
        border: '1px solid #e2e8f0',
      },
      searchItem: {
        background: '#ffffff',
        padding: '0.75rem 1rem',
        borderRadius: '0.85rem',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      }
    };

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
        });
    };

    let CABIN_CLASS="";
    let ORIGIN_CITY="";
    let ORIGIN_CITY_CODE="";
    let ORIGIN_IATA="";
    let DESTINATION_CITY="";
    let DESTINATION_IATA="";
    let DESTINATION_CITY_CODE="";
    let TRAVEL_DATES="";
    let PASSENGERS=[];
    let is_one_way=true;

    if(Array.isArray(flights) && flights.length > 1){
        const flight = flights?.[0];
        const {
            total_amount, 
            total_currency, 
            slices, 
            owner, 
            conditions, 
            available_services, 
            passengers 
        } = flight;

        PASSENGERS=passengers;

        CABIN_CLASS = slices[0]?.segments[0]?.passengers[0]?.cabin?.marketing_name;
        const SEGMENT_LENGTH = slices[0]?.segments?.length;
        ORIGIN_CITY = slices[0].segments[0]?.origin?.city_name;
        DESTINATION_CITY = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination?.city_name;
        ORIGIN_IATA = slices[0]?.segments[0]?.origin?.iata_code;
        ORIGIN_CITY_CODE = slices[0]?.segments[0]?.origin.iata_city_code
        DESTINATION_IATA = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination?.iata_code;
        DESTINATION_CITY_CODE = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination.iata_city_code;
        TRAVEL_DATES=formatDate(slices?.[0]?.segments?.[0]?.departing_at);

        if(slices.length>1){
            const LAST_SLICE_SEG_LENGTH=slices[(slices.length-1)]?.segments?.length;
            if(ORIGIN_CITY===slices[(slices.length-1)]?.segments[LAST_SLICE_SEG_LENGTH-1]?.destination?.city_name){
                is_one_way=false;
                TRAVEL_DATES=(formatDate(slices?.[0]?.segments?.[0]?.departing_at)+" • "+formatDate(slices[(slices.length-1)]?.segments[LAST_SLICE_SEG_LENGTH-1]?.departing_at));
            }
        }
    }

    return <div style={{...styles.searchContainer, display: (showSearchPageForm && "none"), marginTop: (!showSearchPageForm && -40), marginBottom: 10}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col gap-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">
                            {ORIGIN_CITY} to {DESTINATION_CITY}</h1>
                        <span style={{color: bookingEngine?.actionButtonsBg, background: (bookingEngine?.actionButtonsBg+"26"), border: ("1px solid "+bookingEngine?.actionButtonsBg+"26"), marginRight: 10}} className="px-3 py-1 bg-indigo-50 text-indigo-700 text-[10px] font-black uppercase rounded-full border border-indigo-100">
                            {
                                is_one_way ? "One way" :
                                "Round trip"
                            }
                        </span>
                    </div>
                    <button style={{fontWeight: "initial", backgroundColor: bookingEngine?.actionButtonsBg, color: bookingEngine?.actionButtonsTxtColor, borderRadius: bookingEngine?.actionButtonBorderRadius}} onClick={()=>setShowSearchPageForm(!showSearchPageForm)} className="text-sm font-bold text-indigo-600 bg-white border border-slate-200 px-4 py-2 rounded-xl hover:bg-slate-50 transition-colors shadow-sm">
                        Modify Search
                    </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-3" style={styles.searchBar}>
                    <div style={styles.searchItem} className="flex items-center gap-3">
                        <div style={{background: (bookingEngine?.actionButtonsBg+"26")}} className="p-2 bg-slate-50 rounded-lg text-slate-400">
                            <MapPin style={{ width: "16px", height: "16px", color: bookingEngine?.actionButtonsBg}} /></div>
                        <div>
                            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">Origin</p>
                            <p className="text-sm font-bold text-slate-900">{ORIGIN_CITY_CODE} • {ORIGIN_IATA}</p>
                        </div>
                    </div>
                    <div style={styles.searchItem} className="flex items-center gap-3">
                    <div  style={{background: (bookingEngine?.actionButtonsBg+"26")}} className="p-2 bg-indigo-50 rounded-lg text-indigo-600">
                        <MapPin style={{ width: "16px", height: "16px", color: bookingEngine?.actionButtonsBg }} /></div>
                    <div>
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">Destination</p>
                        <p className="text-sm font-bold text-slate-900">{DESTINATION_CITY_CODE} • {DESTINATION_IATA}</p>
                    </div>
                    </div>
                    <div style={styles.searchItem} className="flex items-center gap-3">
                        <div style={{background: (bookingEngine?.actionButtonsBg+"26")}} className="p-2 bg-slate-50 rounded-lg text-slate-400">
                            <CalendarFold style={{ width: "16px", height: "16px", color: bookingEngine?.actionButtonsBg }} /></div>
                        <div>
                            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">Dates</p>
                            <p className="text-sm font-bold text-slate-900">{TRAVEL_DATES}</p>
                        </div>
                    </div>
                    <div style={styles.searchItem} className="flex items-center gap-3">
                        <div style={{background: (bookingEngine?.actionButtonsBg+"26")}} className="p-2 bg-slate-50 rounded-lg text-slate-400">
                            <Users style={{ width: "16px", height: "16px", color: bookingEngine?.actionButtonsBg }} /></div>
                        <div>
                            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">Travelers</p>
                            <p className="text-sm font-bold text-slate-900">{PASSENGERS.length>1?(`${PASSENGERS.length} People`):"1 Person"} • {CABIN_CLASS}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default Type4TopBanner;